// @tennis-matches/clubmeisterschaft-core/manifests – Source of Truth (wie schleifchen-core)

import { ClubmeisterschaftRoot } from "../ui/index.js";
import { ClubmeisterschaftLandingPage } from "../ui/pages/ClubmeisterschaftLandingPage.jsx";
import { ClubmeisterschaftSetupPage } from "../ui/pages/ClubmeisterschaftSetupPage.jsx";
import { ClubmeisterschaftSchedulePlaceholder } from "../ui/pages/ClubmeisterschaftSchedulePlaceholder.jsx";
import { ClubmeisterschaftEntryPlaceholder } from "../ui/pages/ClubmeisterschaftEntryPlaceholder.jsx";
import { ClubmeisterschaftFinishPlaceholder } from "../ui/pages/ClubmeisterschaftFinishPlaceholder.jsx";

/** Route name → React path segment (unter /clubmeisterschaft) */
export const CLUBMEISTERSCHAFT_PATH_MAP = {
  clubmeisterschaft: "",
  "clubmeisterschaft-setup": "setup",
  "clubmeisterschaft-schedule": "schedule",
  "clubmeisterschaft-entry": "entry",
  "clubmeisterschaft-finish": "finish",
};

/** Route name → Component (für Loader/Router) */
export const CLUBMEISTERSCHAFT_ROUTE_TO_COMPONENT = {
  clubmeisterschaft: ClubmeisterschaftLandingPage,
  "clubmeisterschaft-setup": ClubmeisterschaftSetupPage,
  "clubmeisterschaft-schedule": ClubmeisterschaftSchedulePlaceholder,
  "clubmeisterschaft-entry": ClubmeisterschaftEntryPlaceholder,
  "clubmeisterschaft-finish": ClubmeisterschaftFinishPlaceholder,
};

/** Child-Route-Config für React Router: path (relativ zu /clubmeisterschaft) → Component */
export const CLUBMEISTERSCHAFT_CHILD_ROUTES = [
  { index: true, Component: ClubmeisterschaftLandingPage },
  { path: "setup", Component: ClubmeisterschaftSetupPage },
  { path: "schedule", Component: ClubmeisterschaftSchedulePlaceholder },
  { path: "entry", Component: ClubmeisterschaftEntryPlaceholder },
  { path: "finish", Component: ClubmeisterschaftFinishPlaceholder },
];

export const clubmeisterschaftManifest = {
  id: "clubmeisterschaft",
  titleKey: "club.title",
  component: ClubmeisterschaftRoot,
  routes: [
    "clubmeisterschaft",
    "clubmeisterschaft-setup",
    "clubmeisterschaft-entry",
    "clubmeisterschaft-schedule",
    "clubmeisterschaft-finish",
  ],
  routeToComponent: CLUBMEISTERSCHAFT_ROUTE_TO_COMPONENT,
  childRoutes: CLUBMEISTERSCHAFT_CHILD_ROUTES,
  breadcrumbSteps: [
    { route: "clubmeisterschaft", i18nKey: "club.title" },
    { route: "clubmeisterschaft-setup", i18nKey: "club.setup.title" },
    { route: "clubmeisterschaft-schedule", i18nKey: "club.schedule.title" },
    { route: "clubmeisterschaft-entry", i18nKey: "club.entry.title" },
    { route: "clubmeisterschaft-finish", i18nKey: "club.finish.title" },
  ],
  nav: [
    { route: "clubmeisterschaft", i18nKey: "club.title", featureKey: "clubmeisterschaft" },
  ],
};
